module.exports = __webpack_public_path__ + "img/slider_3.651ce405.jpg";